<template>
    <div class="loadBox">
        <div class="loading loading-bg">
            <div class="loader" :class="{ 'loader-small': size === 'small' }" :style="loaderStyle"></div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    size: {
        type: String,
        default: 'large',
        validator: (value) => ['small', 'large'].includes(value)
    },
    color: {
        type: String,
        default: '#ffffff'
    }
});

const loaderStyle = computed(() => ({
    '--loader-color': props.color
}));
</script>

<style scoped>
.loadBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.loader {
    margin: auto;
}

.loader:before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    width: 40px;
    height: 40px;
    margin-top: -20px;
    margin-left: -20px;
    border-radius: 50%;
    border: 4px solid var(--loader-color);
    border-top: 4px solid transparent;
    animation: spin 1s linear infinite;
}

.loader-small:before {
    width: 20px;
    height: 20px;
    margin-top: -10px;
    margin-left: -10px;
    border-width: 2px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>